



























import {Vue, Component} from 'vue-property-decorator'

import {namespace} from 'vuex-class'

import {openNewWindow} from '@/utils'

import InputBank from './contract/InputBank.vue'
import Agreement from './contract/Agreement.vue'
import Completed from './contract/Completed.vue'
import CloseModal from './contract/CloseModal.vue'

const taxrefund = namespace('taxrefund')
const auth = namespace('auth')

@Component({
  components: {
    InputBank, // step 1
    Agreement, // step 2
    Completed, // step 3
    CloseModal,
  },
})
export default class ContactPage extends Vue {
  @auth.State('phone') userPhone: string | null
  @taxrefund.Getter('getSurveyKey') surveyKey: string
  @taxrefund.Action('getTaxRefund') getTaxRefund: () => Promise<void>
  @taxrefund.Action('postSurveyKey') postSurveyKey: () => void
  step = 1
  isShowCloseModal: boolean = false

  onBack() {
    this.step -= 1
    if(this.step <= 0) {
      this.step = 1
      this.$router.push({
        name: 'taxrefund',
      })
    }
  }
  onExit() {
    this.isShowCloseModal = true

  }
  handleCloseRefund() {
    this.$router.push({name: 'home'}).catch((err) => err)
  }
  async onNext() {
    this.step += 1
    if(this.step >= 4) {
      this.step = 3
      const postSurveyKeyEntity = this.postSurveyKey()
      await Promise.all([postSurveyKeyEntity])

      const targetUrl = process.env.NODE_ENV !== 'production' ? 'https://sole-app.stag-a.overtax.co.kr' : 'https://app.sole.overtax.co.kr'

      const surveyUrl = `${targetUrl}/survey/corporation/?session_key=${this.surveyKey}`
      openNewWindow(surveyUrl, '_self')
    }
  }

  async created() {
    const getTaxRefundEntity = this.getTaxRefund()
    await Promise.all([getTaxRefundEntity])
  }
}
